import { IAction, IFormSubmitAction, IPayloadAction } from "core/store";
import * as actions from "./actionTypes";
import { ITechnician } from "./model";

export interface IActionSetTechnicians
  extends IPayloadAction<typeof actions.SET_TECHNICIANS, ITechnician[]> {}
export const setTechnicians = (
  payload: ITechnician[]
): IActionSetTechnicians => ({
  type: actions.SET_TECHNICIANS,
  payload,
});

export interface IActionClearTechnicians
  extends IAction<typeof actions.CLEAR_TECHNICIANS> {}

export const clearTechnicians = (): IActionClearTechnicians => ({
  type: actions.CLEAR_TECHNICIANS,
});

export interface IActionSetIsFetching
  extends IAction<typeof actions.SET_IS_FETCHING_TECHNICIANS> {}

export const setIsFetchingTechnicians = (): IActionSetIsFetching => ({
  type: actions.SET_IS_FETCHING_TECHNICIANS,
});

export interface IActionResetIsFetchingTechnicians
  extends IAction<typeof actions.RESET_IS_FETCHING_TECHNICIANS> {}

export const resetIsFetchingTechnicians =
  (): IActionResetIsFetchingTechnicians => ({
    type: actions.RESET_IS_FETCHING_TECHNICIANS,
  });

interface IActionInviteTechniciansRequestPayload {
  reviewerId: string;
  emails: string[];
}
export interface IActionInviteTechniciansRequest
  extends IFormSubmitAction<
    typeof actions.INVITE_TECHNICIANS,
    IActionInviteTechniciansRequestPayload
  > {}
export const inviteTechniciansRequest = (
  payload: IActionInviteTechniciansRequestPayload,
  formName: string
): IActionInviteTechniciansRequest => ({
  type: actions.INVITE_TECHNICIANS,
  payload,
  form: formName,
});

export interface IActionAddTechnicians
  extends IPayloadAction<typeof actions.ADD_TECHNICIANS, ITechnician[]> {}
export const addTechnicians = (
  payload: ITechnician[]
): IActionAddTechnicians => ({
  type: actions.ADD_TECHNICIANS,
  payload,
});

export interface IActionGetTechniciansRequest
  extends IPayloadAction<typeof actions.GET_TECHNICIANS_REQUEST, string> {}
export const getTechniciansRequest = (
  reviewerId: string
): IActionGetTechniciansRequest => ({
  type: actions.GET_TECHNICIANS_REQUEST,
  payload: reviewerId,
});

interface IActionRemoveTechnicianRequestPayload {
  reviewerId: string;
  technicianId: string;
}
export interface IActionRemoveTechnicianRequest
  extends IPayloadAction<
    typeof actions.REMOVE_TECHNICIAN_REQUEST,
    IActionRemoveTechnicianRequestPayload
  > {}
export const removeTechnicianRequest = (
  payload: IActionRemoveTechnicianRequestPayload
): IActionRemoveTechnicianRequest => ({
  type: actions.REMOVE_TECHNICIAN_REQUEST,
  payload,
});

export interface IActionRemoveTechnician
  extends IPayloadAction<typeof actions.REMOVE_TECHNICIAN, ITechnician> {}
export const removeTechnician = (
  payload: ITechnician
): IActionRemoveTechnician => ({
  type: actions.REMOVE_TECHNICIAN,
  payload,
});

export interface IActionGetRegistrationCodeValidityRequest
  extends IPayloadAction<
    typeof actions.GET_IS_REGISTRATION_CODE_VALID_REQUEST,
    string
  > {}
export const getRegistrationCodeValidityRequest = (
  code: string
): IActionGetRegistrationCodeValidityRequest => ({
  type: actions.GET_IS_REGISTRATION_CODE_VALID_REQUEST,
  payload: code,
});

export interface IActionSetRegistrationCodeValidity
  extends IPayloadAction<
    typeof actions.SET_IS_REGISTRATION_CODE_VALID,
    boolean
  > {}
export const setIsRegistrationCodeValid = (
  isCodeValid: boolean
): IActionSetRegistrationCodeValidity => ({
  type: actions.SET_IS_REGISTRATION_CODE_VALID,
  payload: isCodeValid,
});

export interface IActionResetIsRegistrationCodeValid
  extends IAction<typeof actions.RESET_IS_REGISTRATION_CODE_VALID> {}
export const resetIsRegistrationCodeValid =
  (): IActionResetIsRegistrationCodeValid => ({
    type: actions.RESET_IS_REGISTRATION_CODE_VALID,
  });

export type TAction =
  | IActionSetTechnicians
  | IActionClearTechnicians
  | IActionSetIsFetching
  | IActionResetIsFetchingTechnicians
  | IActionInviteTechniciansRequest
  | IActionGetTechniciansRequest
  | IActionAddTechnicians
  | IActionRemoveTechnicianRequest
  | IActionRemoveTechnician
  | IActionGetRegistrationCodeValidityRequest
  | IActionResetIsRegistrationCodeValid
  | IActionSetRegistrationCodeValidity;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/technicians/actions.ts